import { Link } from 'react-router-dom'
import { Shell } from '../layouts/Shell'

export function NotFoundPage() {
  return (
    <Shell>
      <div
        data-testid="not-found"
        className="rounded-md border border-slate-800 bg-fishstank-surface p-6 text-sm text-slate-300"
      >
        <h1 className="text-lg font-semibold">Not found</h1>
        <p className="mt-2 text-slate-400">
          That admin surface doesn't exist yet.{' '}
          <Link to="/entities" className="text-fishstank-accent hover:underline">
            Go to entities →
          </Link>
        </p>
      </div>
    </Shell>
  )
}
